import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Chart } from 'chart.js';
import { combineLatest, tap } from 'rxjs';
import { TestQualification } from 'src/app/model/testQualification.model';
import { AppelsService } from '../../service/appels.service';

import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { CohorteEnum } from 'src/app/modules/shared/enumeration/cohorte.enum';
import { TableUtil } from 'src/app/utils/TableExport/TableUtili';

const model: any = {
  'Test - Data Engineering': {
    label: 'DEng',
  },
  'Test - Data engineering': {
    label: 'DEng',
  },
  'Test - Commerce Digital': {
    label: 'COM',
  },
  'Test - Cybersécurité': {
    label: 'CyS',
  },
  'Test - Data analysis': {
    label: 'DAna',
  },
  'Test - Traitement de données avancé': {
    label: 'TrDA',
  },
  'Test - Développement mobile': {
    label: 'DEVM',
  },
  'Test - Entreprenariat numérique': {
    label: 'ENUM',
  },
  'Test - Front end': {
    label: 'FRONT',
  },
  'Test - IA': {
    label: 'IA',
  },
  'Test - Low code No code': {
    label: 'LN',
  },
  'Test - Marketing Digital': {
    label: 'Mark',
  },
  'Test - Python': {
    label: 'Pyth',
  },
  'Test - PHP': {
    label: 'PHP',
  },
  'Test - Java': {
    label: 'java',
  },
  'Test - Web3': {
    label: 'Web3',
  },
  'Test - UX/UI': {
    label: 'Ux/Ui',
  },
  'Test - Traitement des données avancée': {
    label: 'TDA',
  },
  'Test - IA-LLM': {
    label: 'LLM',
  },
  'Test - Traitement des données débutant': {
    label: 'TD1',
  },
  'Test - IA pour tous': {
    label: 'IA.T',
  },
  'Test - Tronc commun - Connaissance en numérique et en TIC': {
    label: 'CE',
  },
};

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css'],
})
export class TestComponent implements OnInit, AfterViewInit {
  chart!: any;
  choiceTable: number[] = [];
  ligneDetails!: TestQualification;
  showSpinner = false;

  // ListTestQualification: TestQualification[] = [];
  tableExportOfList: any[] = [];
  tableExportOfListOtherCohorte: any[] = [];
  tableExportOfList_SIG2402: any[] = [];

  tableExportOfStats: { name: string; value: number }[] = [];

  displayedColumns: string[] = [
    'prenom',
    'nom',
    'age',
    'genre',
    'mail',
    'choice',
  ];

  cohorte: any = null;
  tabInscrits: number[] = [];

  dataSource = new MatTableDataSource<TestQualification>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private appelsService: AppelsService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.cohorte = this.route.snapshot.params['cohortId'];
    // console.log("fu",this.cohorte);

    // console.log('cohrte :', this.cohorte);

    // this.getTest();
    this.fetchDataForCohorte();

    this.breadcrumbItems = [
      { label: 'SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidatures/${this.cohorte}`,
      },
      {
        label: "TESTS D'ADMISSIONS",
        url: `/dashboard/appels/test/${this.cohorte}`,
      },
    ];
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;

    // this.getStatsData();
    // this.getStatsDataOtherCohorte();
    // this.fetchDataForCohorte(this.cohorte);
  }

  getTest() {
    this.appelsService.recupTestStats(this.cohorte).subscribe((data) => {
      //console.log('TEST :', data);
    });
  }

  insertOrdered(cohorte: string, name: string, inscrits: number): void {
    const testsName =
      cohorte === 'SIG2408-FODE'
        ? [
          'Test - Data Engineering',
          'Test - Commerce Digital',
          'Test - Cybersécurité',
          'Test - Data analysis',
          'Test - Traitement de données avancé',
          'Test - Développement mobile',
          'Test - Entreprenariat numérique',
          'Test - Front end',
          'Test - IA',
          'Test - Low code No code',
          'Test - Marketing Digital',
          'Test - Python',
          'Test - Web3',
        ]
        : [
          //prod
          'Test - Data engineering',
          'Test - IA',
          'Test - IA pour tous',
          'Test - IA-LLM',
          'Test - Traitement des données avancée',
          'Test - Traitement des données débutant',
        ];
    //test
    // [
    //
    //   'Test - Data Engineering',
    //   'Test - IA',
    //   'Test - IA pour tous',
    //   'Test - IA-LLM',
    //   'Test - Traitement de données avancé',
    //   'Test - Traitement des données débutant',
    // ];

    this.choiceTable = this.choiceTable;
    const testIndex = testsName.indexOf(name);

    if (testIndex !== -1) {
      this.choiceTable[testIndex] = inscrits;
    }

    //console.log('test name', testsName);

    //console.log('choiseTable', this.choiceTable);
    //console.log('testIndex ', testIndex);
  }

  getLabel(cohorte: string) {
    // console.log('cohorte choisie', cohorte);
    return cohorte === 'SIG2412-FODE'
      ? [
        'Test - Data Engineering',
        'IA',
        'IA pour tous',
        'IA-LLM',
        'TDA',
        'TDD',
      ]
      : [
        'Data eng',
        'COM',
        'CyS',
        'DAna',
        'TrDA',
        'DEVM',
        'ENUM',
        'FRONT',
        'IA',
        'LN',
        'Mark',
        'Pyth',
        'Web3',
      ];
  }

  setTestChartOtherCohorte(canvasName: string, choiceTable: number[]) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    const id = this.cohorte;

    // verif k le tableau n'est pas vide
    if (choiceTable.length === 0) {
      // console.error(
      //   'Le tableau des choix est vide, impossible de générer le graphique'
      // );
      return;
    }

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.getLabel(this.cohorte),
          datasets: [
            {
              data: choiceTable,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)',
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)',
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Répartition des statistiques par choix',
            },
          },
          responsive: true,
          scales: {
            x: {
              stacked: false,
            },
            y: {
              stacked: false,
              beginAtZero: true, // Commence l'axe des ordonnées à zéro
            },
          },
        },
      });
    }
  }

  setTestChartOtherCohorte1(
    canvasName: string,
    choiceTable: number[],
    Label: String[],
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    const id = this.cohorte;

    // verif k le tableau n'est pas vide
    if (choiceTable.length === 0) {
      // console.error(
      //   'Le tableau des choix est vide, impossible de générer le graphique'
      // );
      return;
    }

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: Label,
          datasets: [
            {
              data: choiceTable,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)',
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)',
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Répartition des statistiques par choix',
            },
          },
          responsive: true,
          scales: {
            x: {
              stacked: false,
            },
            y: {
              stacked: false,
              beginAtZero: true, // Commence l'axe des ordonnées à zéro
            },
          },
        },
      });
    }
  }

  // =========== TEST DE QUALIFICATION ===========

  fetchDataForCohorte() {
    if (this.cohorte === CohorteEnum.SIG2402) {
      this.getStatsData();
    } else {
      this.getData();
    }
  }


  getData() {
    const dataStats = this.appelsService.recupTestStats(this.cohorte);
    const dataTestQualif = this.appelsService.getAllTestQualification(
      this.cohorte,
    );

    combineLatest([dataStats, dataTestQualif])
      .pipe(
        tap(([dataStats, dataTestQualif]) => {
          const data = dataStats.object || [];
          if (Array.isArray(data)) {
            const aggregated = new Map<
              string,
              { name: string; idCertificat: any; inscrits: number }
            >();

            data.forEach((entry) => {
              if (
                entry?.['Inscrits'] &&
                entry?.['certificate name'] &&
                !isNaN(Number(entry['Inscrits']))
              ) {
                const rawName = entry['certificate name'].trim();
                const key = this.normalizeKey(rawName);

                if (!aggregated.has(key)) {
                  aggregated.set(key, {
                    name: rawName,
                    idCertificat: entry['certificate id'],
                    inscrits: 0,
                  });
                } else {
                  const existing = aggregated.get(key)!;
                  if (rawName.length > existing.name.length) {
                    existing.name = rawName;
                  }
                }
                aggregated.get(key)!.inscrits += Number(entry['Inscrits']);
              }
            });

            this.tableExportOfListOtherCohorte = Array.from(
              aggregated.values(),
            );
            const labelN = this.tableExportOfListOtherCohorte.map(
              (e) => e.name,
            );
            const choiceN = this.tableExportOfListOtherCohorte.map(
              (e) => e.inscrits,
            );

            if (choiceN.length > 0) {
              this.setTestChart1('canvasTest', choiceN, labelN);
            }
          }
          const list = dataTestQualif?.object || [];
          this.dataSource.data = list;
          this.tableExportOfList = list;
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
          }
        }),
      )
      .subscribe({
        error: (err) => console.error('Erreur getData():', err),
      });
  }
  normalizeKey(raw: string): string {
    return raw
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\btest\b/g, '')
      .replace(/[-_]/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\b(de|des|du|la|le|les|d|l)\b/g, '')
      .replace(/e{2,}/g, 'e')
      .replace(/s\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
  getStatsData() {
    this.appelsService
      .getTestStats()

      .subscribe({
        next: (data) => {
          // console.log('data QT ', data.object);
          const labelN = data.object.exportStatsList
            .filter((e: any) => e.value) // Garde seulement les éléments avec une valeur
            .map((e: any) => model[e.name]?.label);
          const choiceN = data.object.exportStatsList
            .filter((e: any) => e.value) // Garde seulement les éléments avec une valeur
            .map((e: any) => e.value);
          //console.log('STATS :', JSON.stringify(data.object));
          this.choiceTable = [];

          // console.log('label :', labelN);

          this.choiceTable.push(data.object.statsByChoice.choiseAlg);
          //console.log('data com :', data.object.statsByChoice.choiseCom);
          this.choiceTable.push(data.object.statsByChoice.choiseCom);

          this.choiceTable.push(data.object.statsByChoice.choiseCyS);
          this.choiceTable.push(data.object.statsByChoice.choiseDAnalysis);
          this.choiceTable.push(data.object.statsByChoice.choiseTraitementDA);
          this.choiceTable.push(data.object.statsByChoice.choiseDevM);
          this.choiceTable.push(data.object.statsByChoice.choiseENumerique);
          this.choiceTable.push(data.object.statsByChoice.choiseFront);
          this.choiceTable.push(data.object.statsByChoice.choiseIA);
          // this.choiceTable.push(data.object.statsByChoice.choiseKnowledgeTic);
          this.choiceTable.push(data.object.statsByChoice.choiseLN);
          this.choiceTable.push(data.object.statsByChoice.choiseMarkitingD);
          this.choiceTable.push(data.object.statsByChoice.choisePhytonJ);
          this.choiceTable.push(data.object.statsByChoice.choiseWeb3);

          this.dataSource.data = data.object.exportTableTestList;
          //console.log('new data source', this.dataSource.data);
          this.dataSource.paginator = this.paginator;

          //Initialisation du Tableau des stats a exporter
          this.tableExportOfStats = data.object.exportStatsList;

          // console.log('choiceTable stats:', this.choiceTable);
          // console.log('table ', data.object.exportTableTestList);
          // console.log('data source : ', this.dataSource.data);
          // console.log('tableExportOfStats :', this.tableExportOfStats);
          // console.log('contrainte ', ![CohorteEnum.SIG2402,CohorteEnum.SIG2408,CohorteEnum.SIG2412].includes(this.cohorte));

          if (
            ![
              CohorteEnum.SIG2402,
              CohorteEnum.SIG2408,
              CohorteEnum.SIG2412,
            ].includes(this.cohorte)
          ) {
            this.setTestChart1('canvasTest', choiceN, labelN);
            return;
          }
          this.setTestChart('canvasTest', this.choiceTable);
        },
      });
  }

  getStatsDataOtherCohorte() {
    const dataS = this.appelsService.recupTestStats(this.cohorte);
    const dataTestQualif = this.appelsService.getAllTestQualification(
      this.cohorte,
    );
    // console.log(
    //   `Données recupTests() de la cohorte ${this.cohorte}, méthode getStatsDataOtherCohorte() : `,
    //   dataS,
    // );
    // console.log(
    //   `Données allTest() de la cohorte ${this.cohorte}, méthode getStatsDataOtherCohorte() : `,
    //   dataTestQualif,
    // );

    combineLatest([dataS, dataTestQualif])
      .pipe(
        tap(([dataS, dataTestQualif]) => {
          // console.log(
          //   'Réponse du backend méthode getStatsDataOtherCohorte():',
          //   dataS,
          // );
          // verif que les données existent et qu'elles sont un tableau
          // Parcourir les données récupérées
          // data.forEach((entry) => {
          //   if (
          //     entry &&
          //     entry['Inscrits'] &&
          //     entry['certificate name'] &&
          //     !isNaN(Number(entry['Inscrits']))
          //   ) {

          //     // this.insertOrdered(
          //     //   this.cohorte,
          //     //   entry['certificate name'],
          //     //   Number(entry['Inscrits'])
          //     // );

          //     // console.log(
          //     //   'number inscrits : ',
          //     //   JSON.stringify(entry['Inscrits'])
          //     // );
          //     // console.log(
          //     //   'number names : ',
          //     //   JSON.stringify(entry['certificate name'])
          //     // );

          //     this.tableExportOfListOtherCohorte.push({
          //       name: entry['certificate name'],
          //       idCertificat: entry['certificate id'],
          //       inscrits: entry['Inscrits'],
          //     });
          //     console.log('table :', this.tableExportOfListOtherCohorte);
          //   }
          // });
          // console.log(
          //   'ChoiceTable méthode getStatsDataOtherCohorte() :',
          //   this.choiceTable,
          // );

          const data = dataS.object || [];

          if (!data || !Array.isArray(data)) {
            console.error(
              'Les données récupérées ne sont pas valides ou sont manquantes (méthode getStatsDataOtherCohorte()):',
              data,
            );
            return;
          }
          this.tableExportOfListOtherCohorte = [];

          const labelN = data
            .filter((e: any) => Number(e['Inscrits']))
            .map((e: any) => model[e['certificate name']]?.label);
          const choiceN = data
            .filter((e: any) => Number(e['Inscrits']))
            .map((e: any) => Number(e['Inscrits']));

          if (choiceN.every((value) => value === 0)) {
            console.warn(
              'Aucune donnée valide pour le graphique (méthode getStatsDataOtherCohorte())',
            );
            return;
          }

          // this.setTestChartOtherCohorte('canvasTest', this.choiceTable);
          this.setTestChart1('canvasTest', choiceN, labelN);

          // console.log(
          //   'List data test (méthode getStatsDataOtherCohorte()):',
          //   JSON.stringify(dataTestQualif),
          // );
          this.dataSource.data = dataTestQualif.object;
          this.dataSource.paginator = this.paginator;
          // console.log(
          //   'data source (méthode getStatsDataOtherCohorte()) :',
          //   this.dataSource.data,
          // );
          this.tableExportOfList = dataTestQualif.object;
          // console.log(
          //   'data table (méthode getStatsDataOtherCohorte(): ',
          //   this.dataSource.data,
          // );
        }),
      )
      .subscribe({
        error: (err) => {
          console.error(
            'Erreur lors de la récupération des statistiques (méthode getStatsDataOtherCohorte())',
            err,
          );
        },
      });
  }

  // ======================================================================

  // Méthode pour dessiner le diagramme Rpartition du nombre d'admis par famille de métier et par genre

  setTestChart(canvasName: string, choiceTable: number[]) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: [
            'DEng',
            'COM',
            'CyS',
            'DAna',
            'TrDA',
            'DEVM',
            'ENUM',
            'FRONT',
            'IA',
            'LN',
            'Mark',
            'Pyth',
            'Web3',
          ],
          datasets: [
            {
              data: choiceTable,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)',
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)',
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: false,
            },
            y: {
              stacked: false,
            },
          },
        },
      });
    }
  }

  setTestChart1(canvasName: string, choiceTable: number[], label: string[]) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: label,
          datasets: [
            {
              data: choiceTable,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)',
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)',
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Répartition des statistiques par choix de certificat',
            },
            legend: {
              display: false,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: false,
            },
            y: {
              stacked: false,
            },
          },
        },
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toggleModalDetails(row: TestQualification) {
    this.ligneDetails = row;
    // this.showDetails = true;
  }

  exportTableOfStats() {
    if (this.cohorte != CohorteEnum.SIG2402) {
      TableUtil.exportArrayToExcel(this.tableExportOfListOtherCohorte);
    } else {
      TableUtil.exportArrayToExcel(this.tableExportOfStats);
    }
  }
  exportTableOfList() {
    TableUtil.exportArrayToExcel(this.tableExportOfList);
    // TableUtil.exportTableToExcel('testQualificationList', 'test_statistiques');
  }
  // exportPDF(): void {
  //   this.appelsService.exportToPDF().subscribe(
  //     (response: Blob) => {
  //       const blob = new Blob([response], { type: 'application/pdf' });
  //       const url = window.URL.createObjectURL(blob);
  //       window.open(url); // Ovr nvll fenêtre
  //     },
  //     (error) => {
  //       console.error('Error exporting PDF:', error);
  //     }
  //   );
  // }

}
